// extracted by mini-css-extract-plugin
export var text = "_10-0";